export default "__VITE_ASSET__Fae_qMFz__"